import { useTranslation } from "react-i18next";
import { CalendarClock, LayoutTemplate, Tv } from "lucide-react";

/** What Flowboard does beyond a slideshow: schedule, templates, TV pairing. */
export function Features() {
  const { t } = useTranslation();
  const items = [
    { icon: Tv, title: t("features.tvTitle"), desc: t("features.tvDesc") },
    { icon: CalendarClock, title: t("features.scheduleTitle"), desc: t("features.scheduleDesc") },
    { icon: LayoutTemplate, title: t("features.templatesTitle"), desc: t("features.templatesDesc") },
  ];
  return (
    <section className="overflow-x-clip bg-gray-50/60 py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">{t("features.title")}</h2>
          <p className="mt-4 text-lg text-gray-500">{t("features.subtitle")}</p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {items.map((f) => (
            <div key={f.title} className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
              <span className="flex size-11 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
                <f.icon className="size-5" />
              </span>
              <h3 className="mt-4 text-lg font-bold text-gray-900">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-500">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
